<template>
  <form>
    <div class="is-padding">
      <div class="columns is-multiline">
        <div class="column">
          <v-input
            id="last_name"
            :name="'last_name'"
            @input="val => user.last_name = val"
            :model="user.last_name"
            :errors-bag="errors"
            ref="input"
            v-validate="'required|min:2'"
            data-vv-value-path="val"
            data-vv-as="Nom">
            <r-label
              slot="label"
              :is-required="true"
              :label="'Nom'"
              :value="user.last_name"></r-label>
          </v-input>
        </div>
        <div class="column">
          <v-input
            id="first_name"
            :name="'first_name'"
            @input="val => user.first_name = val"
            :model="user.first_name"
            :errors-bag="errors"
            v-validate="'required|min:2'"
            data-vv-value-path="val"
            data-vv-as="Prénom">
            <r-label
              slot="label"
              :is-required="true"
              :label="'Prénom'"
              :value="user.first_name"></r-label>
          </v-input>
        </div>

        <div class="column is-12">
          <v-input
            id="account_name"
            :name="'account_name'"
            @input="val => user.account_name = val"
            :model="user.account_name"
            :errors-bag="errors"
            ref="input"
            v-validate="'required|min:2'"
            data-vv-value-path="val"
            data-vv-as="Nom de la société">
            <r-label
              slot="label"
              :is-required="true"
              :label="'Nom de la société'"
              :value="user.account_name"></r-label>
          </v-input>
        </div>

        <div class="column is-12">
          <v-input
            id="phone"
            name="phone"
            @input="user.phone = $event"
            :model="user.phone"
            :errors-bag="errors"
            :input-type="'tel'"
            :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
            data-vv-value-path="val"
            v-validate="'min:10'"
            data-vv-as="Téléphone"
            :has-addons="true">
            <r-label
              slot="label"
              :is-required="false"
              :label="'Téléphone (fixe ou mobile)'"
              :value="user.phone"
              :truncate="false">
              <span
                class="is-padding-left-xsmall"
                v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                <i class="fal fa-info-circle"></i>
              </span>
            </r-label>
            <p
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <span class="icon"><i class="fas fa-phone-office"></i></span>
              </a>
            </p>
          </v-input>
        </div>

        <div class="column is-12">
          <v-input
            id="email"
            name="email"
            @input="user.email = $event"
            :model="user.email"
            :errors-bag="errors"
            v-validate="'min:2'"
            data-vv-value-path="val"
            data-vv-as="Adresse email"
            :has-addons="true">
            <r-label
              slot="label"
              :is-required="false"
              :label="'Adresse email'"
              :value="user.email"></r-label>
            <p
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <span class="icon"><i class="fas fa-paper-plane"></i></span>
              </a>
            </p>
          </v-input>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'UserQuickviewForm',
  props: {
    paramsQuickview: {
      type: Object
    }
  },
  data () {
    return {
      user: {
        first_name: null,
        last_name: null,
        account_name: null
      }
    }
  },
  methods: {
    async submitQuickview () {
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        this.$emit('submitQuickview', { user: this.user })
      }
    }
  }
}
</script>
